import { render } from "./AbtestForm.vue?vue&type=template&id=2654d42c&bindings={\"obj\":\"props\",\"group\":\"props\",\"isLoading\":\"data\",\"errors\":\"data\",\"showSuccessMessage\":\"data\",\"data\":\"data\",\"checklist\":\"options\",\"save\":\"options\"}"
import script from "./AbtestForm.vue?vue&type=script&lang=js"
export * from "./AbtestForm.vue?vue&type=script&lang=js"
script.render = render

export default script